import { Expose } from "class-transformer";

export class AddExpensesToCertificationDto {
  @Expose()
  certificationId: string;

  @Expose()
  expenseIds: string[];
}
